export class VoyageExpensesSegmentModel {
  public fuel_cost_from_last_port_usd?: number;

  constructor() { }

  public fromJSON(json: any): VoyageExpensesSegmentModel {
    if (json) {
      this.fuel_cost_from_last_port_usd = json.fuel_cost_from_last_port_usd;
    }
    return this;
  }

  public fromJSONList(json: any): VoyageExpensesSegmentModel[] {
    if (json) {
      return json.map((element: any) =>
        new VoyageExpensesSegmentModel().fromJSON(element)
      );
    }
    return [];
  }

  public toJSON() {
    return {
      fuel_cost_from_last_port_usd: this.fuel_cost_from_last_port_usd,
    };
  }
}
